import { DonneeAnalyse } from "../bo/donneeAnalyse";
import { MenuItem } from "../bo/menuItem";
import { MenuItemSortHelper } from "./menuItemSort.helper";

export class ItemSortHelper {

    static async sortKpi(items: DonneeAnalyse[]){
    let array: MenuItem[] = [];
    items.forEach((v,i,a)=>{
     const item:MenuItem = {
      translateId:v.referentielDonneeAnalyse.nom,
      translatedName:'',
      activeClass: '',
      tab: 0
     }
     array.push(item);
    })
    array = await new MenuItemSortHelper(array).translateAndSortMenu();
    const sortedArray: DonneeAnalyse[] = []

    for(const item of array) {
     let index = items.findIndex(elem => elem.referentielDonneeAnalyse.nom === item.translateId);
     let itemToAdd = items[index];
     sortedArray.push(itemToAdd);
    }
    return sortedArray
  }


  static arraysHaveSameValues(a: number[], b: number[]): boolean {
    if(a.length !== b.length) return false;
    return a.every(val => b.includes(val));
  }

  /// Returns the elements in a that are not in b
  static arrayDifference(a: number[], b: number[]): number[] {
    return a.filter(val => !b.includes(val));
  }
}
